import React from 'react';
import { HeaderContext } from '../contexts/header-context';
export function useMyLearningStore() {
  const context = React.useContext(HeaderContext);
  if (!(context !== null && context !== void 0 && context.myLearningStore)) {
    throw new Error('myLearningStore is not set in HeaderContext');
  }
  return context.myLearningStore;
}
//# sourceMappingURL=use-my-learning-store.js.map